import authorImg1 from "../../assets/img/faces/face5.jpg";
import authorImg2 from "../../assets/img/faces/face7.jpg";
import authorImg3 from "../../assets/img/faces/face8.jpg";
import commentImg1 from "../../assets/img/blog/face1.jpg";
import commentImg2 from "../../assets/img/blog/face2.jpg";
import commentImg3 from "../../assets/img/blog/face3.jpg";
import commentImg4 from "../../assets/img/blog/face4.jpg";
import commentImg5 from "../../assets/img/blog/face6.jpg";

export const BlogData = {
  posts: [
    {
      id: 1,
      title: "Why Every School Needs a Smart Management Platform",
      image: "/assets/img/blog/blog-1.jpg",
      author: {
        name: "Satyam Rai",
        image: authorImg1,
        bio: "Education technology expert with 10+ years of experience in digital transformation for educational institutions.",
        socialLinks: {
          twitter: "https://twitter.com/janesmith",
          facebook: "https://facebook.com/janesmith",
          linkedin: "https://linkedin.com/in/janesmith",
        },
      },
      date: "June 23, 2025",
      commentCount: 2,
      comments: [
        {
          id: 1,
          imgSrc: commentImg1,
          name: "Aarav Mehta",
          date: "June 23, 2025",
          text: "This is exactly what our school needs. Very well explained!",
        },
        {
          id: 2,
          imgSrc: commentImg2,
          name: "Priya Sharma",
          date: "June 24, 2025",
          text: "We recently adopted a similar system. Huge time-saver!",
        },
      ],
      content: [
        "In today's digital world, managing a school or college with outdated manual methods can lead to inefficiency, errors, and unnecessary stress. A smart school management platform like EduAdminHub helps educational institutions modernize their operations and focus on delivering high-quality education.",
        "EduAdminHub simplifies tasks such as student registration, attendance tracking, fee management, staff coordination, and communication with parents.",
        "With role-based dashboards, everyone — from administrators to teachers and parents — can easily access the information they need. The result is smoother operations, better accuracy, and stronger collaboration.",
        "Key Benefits:",
        "● Save Time: Automate daily tasks to reduce manual work",
        "● Boost Accuracy: Minimize errors in records and reporting",
        "● Improve Communication: Strengthen connections between staff, students, and parents",
        "● Enhanced Security: Protect sensitive student and staff data with advanced security measures",
        "● Real-time Insights: Make data-driven decisions with comprehensive analytics and reports",
        "👉 Ready to transform your school? Explore EduAdminHub or Schedule a Demo",
      ],
      categories: ["Education", "Technology"],
      tags: ["EduTech", "Management", "School Software"],
    },
    {
      id: 2,
      title: "Top 5 IT Solutions That Can Transform Your Business",
      image: "/assets/img/blog/blog-2.jpg",
      author: {
        name: "Rahul Patel",
        image: authorImg2,
        bio: "IT consultant and business strategist specializing in digital transformation and cloud solutions.",
        socialLinks: {
          twitter: "https://twitter.com/janesmith",
          facebook: "https://facebook.com/janesmith",
          linkedin: "https://linkedin.com/in/janesmith",
        },
      },
      date: "July 1, 2025",
      commentCount: 2,
      comments: [
        {
          id: 1,
          imgSrc: commentImg3,
          name: "Rohit Verma",
          date: "July 1, 2025",
          text: "Cloud services and analytics are changing the game for us.",
        },
        {
          id: 2,
          imgSrc: commentImg4,
          name: "Neha Patel",
          date: "July 2, 2025",
          text: "Loved the clear breakdown of the solutions!",
        },
      ],
      content: [
        "Technology drives business success in today's fast-paced world. The right IT solutions can help your company grow faster, work smarter, and stay competitive. At Oethical Technology, we deliver tailored IT services designed for your needs. Here are five solutions that can power your business forward:",
        "1. Custom Software Development:",
        "Build solutions that fit your exact business processes. Custom software eliminates the need to adapt your workflow to generic tools, resulting in increased efficiency and productivity.",
        "2. Cloud Services:",
        "Enable secure, flexible, and scalable operations. Cloud computing allows your business to scale resources on demand, reduce infrastructure costs, and access data from anywhere.",
        "3. Data Analytics:",
        "Turn data into actionable insights for smarter decisions. Advanced analytics help you understand customer behavior, optimize operations, and identify new opportunities.",
        "4. Web & App Development:",
        "Create engaging, user-friendly digital experiences. A strong online presence and mobile apps can significantly expand your reach and improve customer engagement.",
        "5. IT Support & Maintenance:",
        "Keep your systems reliable and always up to date. Proactive maintenance and 24/7 support ensure minimal downtime and maximum productivity.",
        "By adopting these solutions, you can streamline operations, reduce costs, and focus on growth.",
        "👉 Learn more about how we can help: Our Services",
      ],
      categories: ["Technology", "Business"],
      tags: ["IT Solutions", "Digital Transformation", "Business Growth"],
    },
    {
      id: 3,
      title: "How Reliable Support Drives Business Success",
      image: "/assets/img/blog/blog-3.jpg",
      author: {
        name: "Vinod Baghel",
        image: authorImg3,
        bio: "Customer success manager with expertise in IT support and service delivery excellence.",
        socialLinks: {
          twitter: "https://twitter.com/janesmith",
          facebook: "https://facebook.com/janesmith",
          linkedin: "https://linkedin.com/in/janesmith",
        },
      },
      date: "July 5, 2025",
      commentCount: 2,
      comments: [
        {
          id: 1,
          imgSrc: commentImg5,
          name: "Kunal Rao",
          date: "July 5, 2025",
          text: "Support is often underrated. Great to see it highlighted!",
        },
        {
          id: 2,
          imgSrc: commentImg1,
          name: "Sneha Iyer",
          date: "July 6, 2025",
          text: "We've faced similar issues before. Good support changes everything.",
        },
      ],
      content: [
        "Even the best technology needs strong support behind it. Without dependable IT support, your business risks downtime, inefficiency, and frustrated customers. At Oethical Technology, we provide reliable, responsive support to keep your business running smoothly.",
        "Our support services include ticket-based issue tracking, real-time troubleshooting, and regular system maintenance. We focus on preventing problems before they happen and resolving issues fast when they do. Having a trusted IT partner gives you peace of mind and helps you stay focused on your business goals.",
        "Why Oethical Support?",
        "● Quick Response: Get help when you need it most with 24/7 availability",
        "● Proactive Care: We keep your systems healthy with regular monitoring and updates",
        "● Trusted Partnership: Long-term support for your growth with dedicated account managers",
        "● Expert Team: Experienced professionals who understand your business needs",
        "● Cost-Effective: Reduce downtime and operational costs with efficient support",
        "👉 Need dependable IT support? Contact Us today.",
      ],
      categories: ["Support", "Technology"],
      tags: ["IT Support", "Customer Service", "Reliable Service"],
    },
    {
      id: 4,
      title: "The Future of Cloud Computing in Business",
      image: "/assets/img/blog/blog-4.jpg",
      author: {
        name: "Rahul Patel",
        image: authorImg2,
        bio: "Cloud architecture expert helping businesses migrate to scalable cloud solutions.",
        socialLinks: {
          twitter: "https://twitter.com/janesmith",
          linkedin: "https://linkedin.com/in/janesmith",
        },
      },
      date: "July 10, 2025",
      commentCount: 1,
      comments: [
        {
          id: 1,
          imgSrc: commentImg2,
          name: "Ankit Singh",
          date: "July 11, 2025",
          text: "Great insights on cloud computing trends!",
        },
      ],
      content: [
        "Cloud computing has revolutionized how businesses operate, offering unprecedented flexibility, scalability, and cost-efficiency. As we move forward, cloud technology continues to evolve, bringing new opportunities and challenges.",
        "Key Trends in Cloud Computing:",
        "● Hybrid Cloud Solutions: Combining public and private clouds for optimal performance",
        "● Edge Computing: Processing data closer to the source for reduced latency",
        "● Serverless Architecture: Building applications without managing servers",
        "● AI and Machine Learning Integration: Leveraging cloud-based AI services",
        "● Enhanced Security: Advanced encryption and compliance features",
        "Businesses that embrace cloud computing can achieve greater agility, reduce infrastructure costs, and scale operations seamlessly. The future belongs to organizations that can adapt quickly to changing market conditions.",
        "👉 Explore our cloud services and see how we can help your business thrive.",
      ],
      categories: ["Technology", "Cloud"],
      tags: ["Cloud Computing", "Technology", "Business Innovation"],
    },
    {
      id: 5,
      title: "Best Practices for Mobile App Development in 2025",
      image: "/assets/img/blog/blog-5.jpg",
      author: {
        name: "Satyam Rai",
        image: authorImg1,
        bio: "Mobile app developer with expertise in React Native and Flutter development.",
        socialLinks: {
          twitter: "https://twitter.com/janesmith",
          linkedin: "https://linkedin.com/in/janesmith",
        },
      },
      date: "July 15, 2025",
      commentCount: 0,
      comments: [],
      content: [
        "Mobile app development continues to evolve rapidly, with new frameworks, tools, and best practices emerging regularly. To build successful mobile applications in 2025, developers need to stay updated with the latest trends and technologies.",
        "Essential Best Practices:",
        "● User-Centric Design: Prioritize user experience and intuitive interfaces",
        "● Cross-Platform Development: Use frameworks like React Native or Flutter for efficiency",
        "● Performance Optimization: Ensure fast load times and smooth animations",
        "● Security First: Implement robust security measures and data encryption",
        "● Regular Updates: Keep apps updated with new features and bug fixes",
        "● Analytics Integration: Track user behavior to improve app performance",
        "At Oethical Technology, we follow industry best practices to deliver high-quality mobile applications that meet your business objectives and exceed user expectations.",
        "👉 Learn more about our mobile app development services.",
      ],
      categories: ["Technology", "Development"],
      tags: ["Mobile Apps", "Development", "Best Practices"],
    },
    {
      id: 6,
      title: "Cybersecurity Essentials for Modern Businesses",
      image: "/assets/img/blog/blog-6.jpg",
      author: {
        name: "Vinod Baghel",
        image: authorImg3,
        bio: "Cybersecurity expert with 15+ years of experience in protecting business data.",
        socialLinks: {
          twitter: "https://twitter.com/janesmith",
          linkedin: "https://linkedin.com/in/janesmith",
        },
      },
      date: "July 20, 2025",
      commentCount: 1,
      comments: [
        {
          id: 1,
          imgSrc: commentImg3,
          name: "Rajesh Kumar",
          date: "July 21, 2025",
          text: "Very informative article on cybersecurity!",
        },
      ],
      content: [
        "In an increasingly digital world, cybersecurity has become a critical concern for businesses of all sizes. Cyber threats are evolving constantly, making it essential for organizations to implement robust security measures.",
        "Essential Cybersecurity Practices:",
        "● Regular Security Audits: Identify and address vulnerabilities proactively",
        "● Employee Training: Educate staff about phishing and social engineering attacks",
        "● Multi-Factor Authentication: Add an extra layer of security to accounts",
        "● Data Encryption: Protect sensitive information both in transit and at rest",
        "● Backup and Recovery: Ensure regular backups and disaster recovery plans",
        "● Incident Response Plan: Prepare for security breaches with a clear response strategy",
        "At Oethical Technology, we help businesses implement comprehensive cybersecurity solutions to protect their digital assets and maintain customer trust.",
        "👉 Contact us to strengthen your cybersecurity posture.",
      ],
      categories: ["Security", "Technology"],
      tags: ["Cybersecurity", "Security", "Data Protection"],
    },
  ],
  recentPosts: [
    { title: "Top IT Solutions", url: "/blog/it-solutions" },
    { title: "Future of Education", url: "/blog/education-future" },
  ],
};
